import Component from 'vue-class-component'

import { ReactiveVue } from "@skinsoft/reactive-vue"
import { FIELD_VALUE_UPDATED } from '../../events'

@Component({
    props: {
        type: Array,
        fieldId: {
            type: String,
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        error: {
            type: String,
        },
        dataCy: {
            type: String,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        minRows: {
            type: Number
        },
        maxRows: {
            type: Number
        },
    },
    template: require("./text-area.html")
})
export class TextArea extends ReactiveVue {
    private fieldId: String
    private value: String
    private placeholder: String
    private error: String
    private dataCy: String
    private readOnly: Boolean
    private minRows: Number
    private maxRows: Number

    private get valueCopy(): String {
        return this.value
    }

    private set valueCopy(newValue: String) {
        this.$emit(FIELD_VALUE_UPDATED, newValue)
    }
}